export const ADD_TO_CART = "ADD_TO_CART";

export const CART_MESSAGE = "CART_MESSAGE";